'use strict';

// Regola allineata alla configurazione Athena per la Partita IVA italiana.
const ITALIAN_VAT_PATTERN = /^\d{11}$/;
const EIN_TIN_PATTERN = /^(?:\d{3}-\d{2}-\d{4}|\d{2}-\d{7})$/;
const DEFAULT_INVALID = 'Inserisci una Partita IVA valida di 11 cifre.';

function findVatNumberField(root) {
	return root.querySelector('input[data-gigya-name="data.vatNumber"]')
		|| root.querySelector('input[data-gigya-name="vatNumber"]')
		|| root.querySelector('input[data-gigya-name="data.EINnumber"]')
		|| root.querySelector('input[name="data.vatNumber"]')
		|| root.querySelector('input[name="vatNumber"]')
		|| root.querySelector('input[name="data.EINnumber"]');
}

function getInvalidMessage(field) {
	return field.getAttribute('data-lvz-vat-error')
		|| field.getAttribute('data-error-invalid')
		|| field.getAttribute('data-display-name')
		|| DEFAULT_INVALID;
}

function ensureErrorElement(field) {
	const control = field.closest('.gigya-composite-control') || field.parentNode;
	let errorElement = control.querySelector('.lvz-gigya-vat-error');

	if (errorElement) {
		return errorElement;
	}

	errorElement = document.createElement('span');
	errorElement.className = 'lvz-gigya-vat-error';
	errorElement.setAttribute('role', 'alert');
	errorElement.setAttribute('aria-live', 'polite');

	// Il messaggio custom resta separato da quello nativo (es. campo obbligatorio).
	const gigyaMessage = control.querySelector('.gigya-error-msg');
	if (gigyaMessage && gigyaMessage.parentNode) {
		gigyaMessage.parentNode.insertBefore(errorElement, gigyaMessage.nextSibling);
	} else if (field.parentNode) {
		field.parentNode.insertBefore(errorElement, field.nextSibling);
	} else {
		control.appendChild(errorElement);
	}

	return errorElement;
}

function isEinTinField(field) {
	const fieldName = field && (field.getAttribute('data-gigya-name') || field.getAttribute('name'));
	return fieldName === 'data.EINnumber';
}

function hasValidFormat(value, fieldName) {
	// Il required continua a essere gestito dalla configurazione dello screen-set Gigya.
	if (!value) {
		return true;
	}

	if (fieldName === 'data.EINnumber') {
		return EIN_TIN_PATTERN.test(value);
	}

	return ITALIAN_VAT_PATTERN.test(value);
}

function vatNumberValidation(root) {
	if (!root) {
		return null;
	}

	const field = findVatNumberField(root);
	if (!field) {
		return null;
	}

	if (field.getAttribute('data-lvz-vat-bound') === '1') {
		return field._lvzVatNumberValidation || null;
	}
	field.setAttribute('data-lvz-vat-bound', '1');

	let touched = false;
	const errorElement = ensureErrorElement(field);

	function clearError() {
		errorElement.textContent = '';
		errorElement.classList.remove('is-visible');

		const control = field.closest('.gigya-composite-control') || field.parentNode;
		const gigyaMessage = control.querySelector('.gigya-error-msg');
		const gigyaHasMessage = gigyaMessage && String(gigyaMessage.textContent || '').trim();

		if (!gigyaHasMessage) {
			field.classList.remove('gigya-error');
			field.removeAttribute('aria-invalid');
		}
	}

	function showFormatError() {
		field.classList.remove('gigya-valid');
		field.classList.add('gigya-error');
		field.setAttribute('aria-invalid', 'true');
		errorElement.textContent = getInvalidMessage(field);
		errorElement.classList.add('is-visible');
	}

	function update() {
		if (!touched) {
			return;
		}

		const fieldName = isEinTinField(field) ? 'data.EINnumber' : 'vatNumber';
		if (hasValidFormat(String(field.value || '').trim(), fieldName)) {
			clearError();
		} else {
			showFormatError();
		}
	}

	function isValid() {
		const fieldName = isEinTinField(field) ? 'data.EINnumber' : 'vatNumber';
		return hasValidFormat(String(field.value || '').trim(), fieldName);
	}

	function markTouched() {
		touched = true;
		update();
	}

	field.addEventListener('input', function () {
		touched = true;
		update();
	});
	field.addEventListener('blur', function () {
		touched = true;
		update();
	});

	const api = {
		isValid: isValid,
		markTouched: markTouched
	};
	field._lvzVatNumberValidation = api;
	return api;
}

vatNumberValidation.hasValidFormat = hasValidFormat;

module.exports = vatNumberValidation;
